import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';

export default function LiveSessionType({ content }) {
  const mFirstCategoryTag = content.GetFirstTagOfType(
    //@ts-ignore
    CrowdHub_App.TAGTYPE_SESSION,
  );

  const aSessionType =
    content.MetaDataSingleValueForKey(
      //@ts-ignore
      CrowdHub_App.META_SESSION_TAG_DISPLAY_NAME,
    ) ||
    mFirstCategoryTag?.Name ||
    content.FirstBucketDisplay();

  const sanitizedSessionType = useMemo(() => {
    const sanitizedString = DOMPurify.sanitize(aSessionType as string, {});
    return sanitizedString;
  }, [aSessionType]);

  let aIcon = FontAwesomeConfigurations.ICON_PANEL;

  if (mFirstCategoryTag != null) {
    switch (mFirstCategoryTag.Id) {
      //@ts-ignore
      case CrowdHub_App.TAGID_MAINEVENT:
        aIcon = FontAwesomeConfigurations.ICON_MAINSTAGE;
        break;
      //@ts-ignore
      case CrowdHub_App.TAGID_BREAKOUT:
        aIcon = FontAwesomeConfigurations.ICON_BREAKOUT;
        break;
      //@ts-ignore
      case CrowdHub_App.TAGID_PANEL:
        aIcon = FontAwesomeConfigurations.ICON_PANEL;
        break;
    }
  }

  return (
    <div className={`livesession_type`}>
      <div className={`livesession_icon`}>
        <i className={aIcon}></i>
      </div>
      {/** @ts-ignore */}
      {!CrowdHub_App.CONFIG.HIDE_SESSION_TYPE && (
        <div className={`livesession_type`} dangerouslySetInnerHTML={{ __html: sanitizedSessionType }}></div>
      )}
    </div>
  );
}
